module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-footer ibox-footer-edit-commodity",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-4",
    class: {
      'col-lg-4': _vm.creatingNewCommodity, 'col-lg-2': _vm.editingExistingCommodity
    }
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Commodity Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commodity.name),
      expression: "commodity.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Commodity Name",
      "name": "name"
    },
    domProps: {
      "value": (_vm.commodity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commodity.name = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-4 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group-outer form-group-outer-description"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Charge Type")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "chargeType",
      "options": _vm.chargeTypeOptions
    },
    model: {
      value: (_vm.commodity.charge_type),
      callback: function($$v) {
        _vm.commodity.charge_type = $$v
      },
      expression: "commodity.charge_type"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-4 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group-outer form-group-outer-description"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Common")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "common",
      "options": _vm.commonOptions
    },
    model: {
      value: (_vm.commodity.common),
      callback: function($$v) {
        _vm.commodity.common = $$v
      },
      expression: "commodity.common"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-4 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group-outer form-group-outer-description"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "status",
      "options": _vm.statusOptions
    },
    model: {
      value: (_vm.commodity.status),
      callback: function($$v) {
        _vm.commodity.status = $$v
      },
      expression: "commodity.status"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4 col-lg-2"
  }, [(_vm.commodity.id) ? _c('ladda-button', {
    staticClass: "m-t-sm m-b-sm",
    attrs: {
      "type": "success",
      "size": "small",
      "max-width": true,
      "on-click": _vm.handleSaveCommodity
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Save")]) : _c('ladda-button', {
    staticClass: "m-t-sm m-b-sm",
    attrs: {
      "max-width": true,
      "size": "small",
      "on-click": _vm.handleSaveCommodity
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add")])], 1), _vm._v(" "), (_vm.editingExistingCommodity) ? _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4 col-lg-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-danger btn-block m-t-sm m-b-sm",
    on: {
      "click": _vm.clearCommodity
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-4 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Show Archived")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archived),
      expression: "archived"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-archive",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.archived) ? _vm._i(_vm.archived, null) > -1 : (_vm.archived)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.archived,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.archived = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.archived = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.archived = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-archive"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tYes\n\t\t\t\t\t\t\t\t\t")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-commodity-types"
  }, _vm._l((_vm.commodities), function(commodity) {
    return _c('li', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-8 col-md-5"
    }, [_c('p', {
      staticClass: "truncate"
    }, [_vm._v(_vm._s(commodity.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-md-2"
    }, [_c('p', {
      staticClass: "text-charge-type"
    }, [_vm._v(_vm._s(commodity.charge_type))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-5"
    }, [(!commodity.deleted_at) ? _c('div', {
      staticClass: "btn-toolbar pull-right"
    }, [_c('span', {
      staticClass: "status ",
      class: {
        'status-enabled': commodity.status, 'status-disabled': !commodity.status
      }
    }, [_vm._v("\n                    " + _vm._s(commodity.status ? 'Enabled' : 'Disabled') + "\n                  ")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-circle-sm",
      class: {
        'btn-success': commodity.common, 'btn-default': !commodity.common
      },
      on: {
        "click": function($event) {
          _vm.handleChangeCommon(commodity)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-star': _vm.notChangingCommodity(commodity.id) && commodity.common,
          'fa-star-o': _vm.notChangingCommodity(commodity.id) && !commodity.common,
          'fa-circle-o-notch fa-spin': _vm.changingCommodity(commodity.id)
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-circle-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.handleArchive(commodity.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-archive': _vm.notArchivingCommodity(commodity.id), 'fa-circle-o-notch fa-spin': _vm.archivingCommodity(commodity.id)
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-circle-sm btn-info",
      on: {
        "click": function($event) {
          _vm.handleEditCommodity(commodity)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]) : _vm._e()])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoCommodities),
      expression: "haveNoCommodities"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("There are no commodities.")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('strong', [_vm._v("Add / Edit Commodity")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-a868c176"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/system/Commodities.vue
// module id = 1069
// module chunks = 0